import { Company } from 'api';
import { FIRM_WATERFALLS_SLUG, INTELLIGENCE_SLUG } from 'common/constants/firms';
import { NavItemDef } from './PrimaryNavigation.types';

export const PRIMARY_NAV_LABELS = {
  INTELLIGENCE: 'Intelligence',
  VALUATIONS: 'Valuations',
  WATERFALLS: 'Waterfalls',
  DOCUMENTS: 'Documents',
} as const;

export const PRIMARY_NAV_SLUGS = {
  INTELLIGENCE: INTELLIGENCE_SLUG,
  VALUATIONS: 'valuations',
  WATERFALLS: FIRM_WATERFALLS_SLUG,
  DOCUMENTS: 'documents',
} as const;

export const ENABLED_PRIMARY_NAV_SLUGS = new Set<string>([
  PRIMARY_NAV_SLUGS.INTELLIGENCE,
  PRIMARY_NAV_SLUGS.VALUATIONS,
  PRIMARY_NAV_SLUGS.WATERFALLS,
  PRIMARY_NAV_SLUGS.DOCUMENTS,
]);

export const PRIMARY_NAV_ITEMS: NavItemDef[] = [
  { label: PRIMARY_NAV_LABELS.INTELLIGENCE, slug: PRIMARY_NAV_SLUGS.INTELLIGENCE },
  { label: PRIMARY_NAV_LABELS.VALUATIONS, slug: PRIMARY_NAV_SLUGS.VALUATIONS },
  { label: PRIMARY_NAV_LABELS.WATERFALLS, slug: PRIMARY_NAV_SLUGS.WATERFALLS },
  { label: PRIMARY_NAV_LABELS.DOCUMENTS, slug: PRIMARY_NAV_SLUGS.DOCUMENTS },
];

export const PRIMARY_NAV_INCLUDED_COMPANY_TYPES = new Set<Company.type>([
  Company.type.HOLDING,
  Company.type.PORTFOLIO,
  Company.type.STANDALONE,
]);

export const APP_SWITCHER_APPS = ['valuations', 'workboard'] as const;

export const PRIMARY_NAV_MENU_VISIBLE_ITEM_LIMIT = 10;

export const PRIMARY_NAVIGATION_ARIA_LABEL = 'Primary navigation';
export const PRIMARY_NAVIGATION_USER_MENU_ARIA_LABEL = 'User menu';
export const PRIMARY_NAVIGATION_UTILITIES_MENU_ARIA_LABEL = 'Utilities menu';
export const PRIMARY_NAVIGATION_MEASUREMENT_DATE_DISABLED_LABEL = 'Create a company before adding measurement dates.';
